// sale page videos to stop autoplaying

document.addEventListener('DOMContentLoaded', function () {
  const page = document.querySelector('.sale-page-v');
  if (!page) return;

  const containers = page.querySelectorAll('.custom-video-container');

  containers.forEach(container => {
    const video = container.querySelector('.custom-video');
    const thumbnail = container.querySelector('.video-thumbnail');
    const playButton = container.querySelector('.play-button');

    function playVideo() {
      thumbnail.style.display = 'none';
      video.style.display = 'block';
      video.play();
      playButton.style.display = 'none';
    }

    playButton.addEventListener('click', playVideo);
    thumbnail.addEventListener('click', playVideo);

    video.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        playButton.style.display = 'none';
      } else {
        video.pause();
        playButton.style.display = 'flex';
      }
    });

    video.addEventListener('pause', function () {
      playButton.style.display = 'flex';
    });

    video.addEventListener('play', function () {
      playButton.style.display = 'none';
    });
  });
});


// END

